import { boatDisplayText, numbersOnly } from "legacy/helpers.es6"
import { validatorFactory } from "legacy/validatorFactory"
import PropTypes from "prop-types"
import React from "react"

class AddBoatPageTwo extends React.Component {
  constructor(props) {
    super(props)
    this.validator = validatorFactory()
    this.setLoa = this.setLoa.bind(this)
    this.setBeam = this.setBeam.bind(this)
    this.setDraft = this.setDraft.bind(this)
    this.nextButton = this.nextButton.bind(this)
  }

  componentDidMount() {
    this.props.setHeader("Boat Dimensions")
  }

  setLoa(event) {
    this.props.setGlobalState({ loa: numbersOnly(event.target.value) })
  }

  setBeam(event) {
    this.props.setGlobalState({ beam: numbersOnly(event.target.value) })
  }

  setDraft(event) {
    this.props.setGlobalState({ draft: numbersOnly(event.target.value) })
  }

  nextButton() {
    this.validator.showMessages()
    this.setState({ validInputs: this.validator.allValid() })
    this.props.setGlobalState({
      boatDisplayText: boatDisplayText(
        this.props.state.boatName,
        this.props.state.loa,
        this.props.state.boatMake
      ),
    })
    if (this.validator.allValid() === true) {
      this.props.routeTo("next")
    }
  }

  render() {
    return (
      <div className="add-boat-page-two">
        <div className="flex-group-2">
          <div className="form-group">
            <label htmlFor="lengthOverall">Length overall</label>
            <div className="form-control-with-icon">
              <span className="form-control-icon-right">ft</span>
              <input
                id="lengthOverall"
                type="tel"
                className="form-control"
                value={this.props.loa}
                onChange={this.setLoa}
                autoFocus
              />
              {this.validator.message(
                "length overall",
                this.props.loa,
                "required|numeric|min:1,num|max:2000,num"
              )}
            </div>
          </div>
          <p>
            Please round up to the nearest foot and include bowsprit, swim
            platform, davits, etc.
          </p>
        </div>
        <div className="flex-group-2">
          <div className="form-group">
            <label htmlFor="beam">Beam</label>
            <div className="form-control-with-icon">
              <span className="form-control-icon-right">ft</span>
              <input
                id="beam"
                type="tel"
                className="form-control"
                value={this.props.beam}
                onChange={this.setBeam}
              />
              {this.validator.message(
                "beam",
                this.props.beam,
                "required|numeric|min:1,num|max:1000,num"
              )}
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="draft">Draft</label>
            <div className="form-control-with-icon">
              <span className="form-control-icon-right">ft</span>
              <input
                id="draft"
                type="tel"
                className="form-control"
                value={this.props.draft}
                onChange={this.setDraft}
              />
              {this.validator.message(
                "draft",
                this.props.draft,
                "required|numeric|min:1,num|max:1000,num"
              )}
            </div>
          </div>
        </div>
        <button
          type="button"
          className="btn btn-primary"
          onClick={this.nextButton}
        >
          Continue
        </button>
      </div>
    )
  }
}

AddBoatPageTwo.propTypes = {
  setGlobalState: PropTypes.func.isRequired,
  setHeader: PropTypes.func.isRequired,
  routeTo: PropTypes.func.isRequired,
  state: PropTypes.shape({
    boatName: PropTypes.string,
    boatMake: PropTypes.string,
    loa: PropTypes.string,
  }),
  loa: PropTypes.string,
  beam: PropTypes.string,
  draft: PropTypes.string,
}

export default AddBoatPageTwo
